import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ICompanyMSServiceDocument } from '~/types/document/models'

export const {
  getDocumentListData: getCompanyMSServiceDocumentListData,
  getDocumentDataById: getCompanyMSServiceDocumentDataById,
  getDocumentListDataByParentId: getCompanyMSServiceDocumentListDataByCMSSId,
} = makeDocumentMockData<ICompanyMSServiceDocument>({
  entityName: 'companyMSService',
  storageKeyPrefix: 'companymsservice',
})
